var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6654 26.6663V34.9997M16.6654 26.6663H23.332M16.6654 26.6663L14.9987 14.9997M23.332 26.6663V34.9997M23.332 26.6663L24.9987 14.9997M14.9987 14.9997H24.9987M14.9987 14.9997C12.777 14.9997 10.5537 16.1113 8.33203 18.333M24.9987 14.9997C27.2204 14.9997 29.4437 16.1113 31.6654 18.333M16.6654 6.66634C16.6654 7.5504 17.0166 8.39824 17.6417 9.02336C18.2668 9.64849 19.1146 9.99967 19.9987 9.99967C20.8828 9.99967 21.7306 9.64849 22.3557 9.02336C22.9808 8.39824 23.332 7.5504 23.332 6.66634C23.332 5.78229 22.9808 4.93444 22.3557 4.30932C21.7306 3.6842 20.8828 3.33301 19.9987 3.33301C19.1146 3.33301 18.2668 3.6842 17.6417 4.30932C17.0166 4.93444 16.6654 5.78229 16.6654 6.66634Z",
    stroke: "#353343",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMan);
export default __webpack_public_path__ + "static/media/man.79bd733cd6c8eb903fc725dcdbdb372c.svg";
export { ForwardRef as ReactComponent };